import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { LocationServingRuleListResponse } from './types';

export function useLocationServingRules({
  locationId,
}: {
  locationId?: string;
}) {
  const {
    data,
    error,
    isLoading,
    mutate,
  }: {
    data?: LocationServingRuleListResponse;
    error?: unknown;
    isLoading: boolean;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    locationId
      ? `new-sales-tax/locations/${locationId}/serving-rules`
      : null,
    SWRFetcher({ method: 'GET' }, undefined)
  );

  return {
    servingRules: data?.data?.serving_rules ?? [],
    error,
    isLoading,
    mutate,
  };
}
